var _rect, _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 107,
    height: 88,
    rx: 9.5,
    fill: "white",
    stroke: "#0076FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 47.2039V71.5H14.5V62.2071L32.4903 44.2168L41.137 53.3439L41.4903 53.7168L41.8536 53.3536L70.4961 24.711L92.5 47.2039Z",
    fill: "#CDE4FD",
    stroke: "#0076FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 11.5,
    fill: "white",
    stroke: "#0076FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 84,
    r: 11.5,
    fill: "#CDE4FD",
    stroke: "#0076FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.139 85.032H108.587V91.64H107.383V85.032H100.859V83.968H107.383V77.36H108.587V83.968H115.139V85.032Z",
    fill: "#0076FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimage);
export default __webpack_public_path__ + "static/media/upload image.187c96c3f31ab6721edceb7a91314ad0.svg";
export { ForwardRef as ReactComponent };